import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    REINITIALIZE,
    DOB_SET_VALUE,
    DOB_SET_VALID,
    // AGE_BAND_SET_VALUE,
    // AGE_BAND_SET_VALID,
    FULL_NAME_SET_VALUE,
    FULL_NAME_SET_VALID,
    PHONE_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALID,
    EMAIL_SET_VALUE,
    EMAIL_SET_VALID,
    TITLE_SET_VALUE,
    TITLE_SET_VALID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    KRA_NUMBER_SET_VALUE,
    KRA_NUMBER_SET_VALID,
    ID_DOC_SET_VALUE,
    ID_DOC_SET_VALID,
    ID_DOC_RESET_VALUE,
    KRA_PIN_DOC_SET_VALUE,
    KRA_PIN_DOC_SET_VALID,
    KRA_PIN_RESET_VALUE,
    PASSPORT_DOC_SET_VALUE,
    PASSPORT_DOC_SET_VALID,
    PASSPORT_DOC_RESET_VALUE,
    ID_TYPE_SET_VALUE,
    ID_TYPE_SET_VALID,
    FORM_VALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM,
    FORM_INVALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM,
    COLLECT_TRAVEL_DETAILS_FORM_DATA,
    API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM,
    API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM,
    API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM,
    TRAVELLERS_SET_VALUE,
    TRAVELLER_SET_VALUE,
    UPDATE_TRAVELLER_VALUE,
    SUBMIT_TRAVEL_DETAILS_FAILURE,
    SUBMIT_TRAVEL_DETAILS_SUCCESS,
    SET_CURRENT_TRAVELLER_INDEX,
    SET_TRAVELLERS_ID_VALUE,
    POPULATE_FORM,
    FULL_NAME_EMERGENCY_SET_VALUE,
    PHONE_NUMBER_EMERGENCY_SET_VALUE,
    EMAIL_EMERGENCY_SET_VALUE,
    EMAIL_EMERGENCY_SET_VALID,
    FULL_NAME_EMERGENCY_SET_VALID,
    PHONE_NUMBER_EMERGENCY_SET_VALID,
    PASSPORT_SET_VALUE,
    PASSPORT_SET_VALID,
    REFERRED_SET_VALUE,
    REFERRED_SET_VALID,
    PERSONAL_DETAILS_ID_SET_VALID,
    PERSONAL_DETAILS_ID_SET_VALUE,
} from '../../actions/travelKe/personalDetails';

export const initPersonal = {
    formStatus: FORM_STATUS.INVALID,
    personalDetailId: 0,
    dropOffDetails: null,
    personalDetailsReferenceData: null,
    apiCallStatus: null,
    travellers: [],
    currentTravellerIndex: null,
    emergency: {
        fullName: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
    },
    form: {
        title: { value: null, error: null, status: null },
        fullName: { value: null, error: null, status: null },
        // ageBand: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        idType: { value: null, error: null, status: null },
        kraNumber: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        idNumber: { value: null, error: null, status: null },
        passport: { value: null, error: null, status: null },
        travellerId: { value: null, error: null, status: null },
        referred: { value: null, error: null, status: null },
        idDoc: { value: null, error: null, status: null },
        kraPinDoc: { value: null, error: null, status: null },
        passportDoc: { value: null, error: null, status: null },
    },
};

export default (state = initPersonal, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    const updateEmergencyField = (fieldId, update) => ({
        ...state,
        emergency: {
            ...state.emergency,
            [fieldId]: update(state.emergency[fieldId]),
        },
    });

    switch (action.type) {
        case PERSONAL_DETAILS_ID_SET_VALUE:
            return { ...state, personalDetailId: action.value };

        case PERSONAL_DETAILS_ID_SET_VALID:
            return { ...state, personalDetailId: 0 };

        case REFERRED_SET_VALUE:
            return updateFormField('referred', (field) => ({
                ...field,
                value: action.value,
            }));

        case REFERRED_SET_VALID:
            return updateFormField('referred', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FORM_VALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case TRAVELLERS_SET_VALUE:
            return { ...state, travellers: action.value };

        case SET_CURRENT_TRAVELLER_INDEX:
            return { ...state, currentTravellerIndex: action.value };

        case TRAVELLER_SET_VALUE:
            return { ...state, travellers: [...state.travellers, action.value] };

        case UPDATE_TRAVELLER_VALUE:
            // let index = state?.travellers
            //     .map(function (traveller) {
            //         return traveller.travellerId.value;
            //     })
            //     .indexOf(action.id);

            // let updatedTravellers = state?.travellers;
            // updatedTravellers[index] = action.value;

            function replaceObjectById(arr, id, newObject) {
                return arr.map((obj) => (obj.travellerId.value === id ? newObject : obj));
            }
            const newArray = replaceObjectById(state?.travellers, action.id, action.value);
            return { ...state, travellers: newArray };

        // case AGE_BAND_SET_VALUE:
        //     return updateFormField('ageBand', (field) => ({
        //         ...field,
        //         value: action.value,
        //     }));

        // case AGE_BAND_SET_VALID:
        //     return updateFormField('ageBand', (field) => ({
        //         ...field,
        //         error: action.error,
        //         status: mapError(action.error),
        //     }));

        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SET_TRAVELLERS_ID_VALUE:
            return updateFormField('travellerId', (field) => ({
                ...field,
                value: action.value,
            }));

        case FULL_NAME_SET_VALUE:
            return updateFormField('fullName', (field) => ({
                ...field,
                value: action.value,
            }));
        case FULL_NAME_SET_VALID:
            return updateFormField('fullName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case ID_TYPE_SET_VALUE:
            return updateFormField('idType', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_TYPE_SET_VALID:
            return updateFormField('idType', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PHONE_NUMBER_SET_VALUE:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case PHONE_NUMBER_SET_VALID:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));

        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case TITLE_SET_VALUE:
            return updateFormField('title', (field) => ({
                ...field,
                value: action.value,
            }));

        case TITLE_SET_VALID:
            return updateFormField('title', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_SET_VALUE:
            return updateFormField('passport', (field) => ({
                ...field,
                value: action.value,
            }));

        case PASSPORT_SET_VALID:
            return updateFormField('passport', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case KRA_NUMBER_SET_VALUE:
            return updateFormField('kraNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case KRA_NUMBER_SET_VALID:
            return updateFormField('kraNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case KRA_PIN_DOC_SET_VALUE:
            return updateFormField('kraPinDoc', (field) => ({
                ...field,
                value: action.value,
            }));

        case KRA_PIN_RESET_VALUE:
            return updateFormField('kraPinDoc', (field) => ({
                ...field,
                value: null,
            }));

        case KRA_PIN_DOC_SET_VALID:
            return updateFormField('kraPinDoc', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_DOC_SET_VALUE:
            return updateFormField('idDoc', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_DOC_SET_VALID:
            return updateFormField('idDoc', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_DOC_RESET_VALUE:
            return updateFormField('idDoc', (field) => ({
                ...field,
                value: null,
            }));

        case PASSPORT_DOC_SET_VALUE:
            return updateFormField('passportDoc', (field) => ({
                ...field,
                value: action.value,
            }));

        case PASSPORT_DOC_SET_VALID:
            return updateFormField('passportDoc', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case PASSPORT_DOC_RESET_VALUE:
            return updateFormField('passportDoc', (field) => ({
                ...field,
                value: null,
            }));

        case FULL_NAME_EMERGENCY_SET_VALUE:
            return updateEmergencyField('fullName', (field) => ({
                ...field,
                value: action.value,
            }));
        case PHONE_NUMBER_EMERGENCY_SET_VALUE:
            return updateEmergencyField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMAIL_EMERGENCY_SET_VALUE:
            return updateEmergencyField('email', (field) => ({
                ...field,
                value: action.value,
            }));

        case EMAIL_EMERGENCY_SET_VALID:
            return updateEmergencyField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FULL_NAME_EMERGENCY_SET_VALID:
            return updateEmergencyField('fullName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case PHONE_NUMBER_EMERGENCY_SET_VALID:
            return updateEmergencyField('phoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        //    API Calls
        case API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        // Submit user data
        case COLLECT_TRAVEL_DETAILS_FORM_DATA:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case SUBMIT_TRAVEL_DETAILS_SUCCESS:
            return { ...state, personalDetailsReferenceData: action.value };
        case SUBMIT_TRAVEL_DETAILS_FAILURE:
            return { ...state, personalDetailsReferenceData: action.error };
        case POPULATE_FORM:
            return {
                ...state,
                form: action.value,
            };
        // Reset the state
        case REINITIALIZE:
            return {
                ...state,
                form: initPersonal.form,
            };

        default:
            return state;
    }
};
